export default {
  base_comp_rule: '活动规则',
  base_comp_awards: '我的奖品',
  act_not_start_yet: '活动未开始',
  act_end: '活动已结束',
  lottery_chance_note: '您还有 {0} 次抽奖机会',
  act_risk_error: '账号异常，暂时无法参与活动',
  act_risk_error_tip: '',
  act_access_error: '很遗憾，您无法参与此活动',
  act_access_error_tip: '',
  use_out_of_chance: '抽奖机会已用完',
  draw_req_timeout: '活动火爆，如已中奖，奖励将稍后放入[我的奖励]中',
  award_not_available: '很遗憾，您与奖励擦肩而过',
  wind_modal: {
    congratulation: '恭喜你获得!',
    name: '{name}',
    note: '以上奖励已放入【我的奖励】',
    redeem_now: '我知道了'
  },
  no_prize_model: {
    title: '很遗憾你没有中奖～'
  },
  task_panel: {
    show_all: '展开全部任务',
    hide: '收起更多任务',
    do_task: '去完成',
    try_tomorrow: '明日再来',
    completed: '已完成',
    earn: '获得',
    chance: '次抽奖机会',
    not_ready: '未开始',
    expired: '已失效',
    signin_success: '签到成功'
  },
  my_awards: {
    valid_date: '有效期',
    dateFormat: '',
    use_coupon: '去使用',
    no_awards: '您还没有任何奖励哦～',
    no_more: '没有更多了~'
  },
  page_my_awards: '我的奖励',
  page_account_error: '账号异常',
  page_access_error: '准入失败',
  page_rule: '活动规则',
  track: {
    base_comp_rule: '活动规则',
    base_comp_awards: '我的奖品',
    base_comp_broadcast: '跑马灯',
    base_comp_primary_btn: '普通按钮',
    base_comp_footer_btn: '吸底悬浮按钮',
    base_comp_float_btn: '悬浮球',
    base_comp_img: '图片',
    base_comp_advertise: '活动资源位',
    turnplate_btn: '大转盘_抽奖按钮',
    lucky_box_btn: '开盒子{n}_开',
    popup_coupon: '优惠券弹窗'
  }
};
